import i18n from './i18n';
var Strings = {
    ModalTitle: {
        uploadImage: i18n.t('upload_image'),
        adjustImage: i18n.t('adjust_image'),
        previewImage: i18n.t('preview_image'),
    },
    ModalFooter: {
        viewImageGuidelines: i18n.t('view_image_guidelines'),
        cancel: i18n.t('cancel_button'),
        back: i18n.t('back_button'),
        next: i18n.t('next_button'),
        save: i18n.t('save_button'),
    },
    FileUploadView: {
        viewImageGuidelines: i18n.t('view_image_guidelines'),
        imageFormatText: {
            acceptedFileTypes: i18n.t('accepted_file_type'),
            minResolution: function (uploadImageMinWidth, uploadImageMinHeight) {
                return i18n.t('min_resolution', { uploadImageMinWidth: uploadImageMinWidth, uploadImageMinHeight: uploadImageMinHeight });
            },
            maxFileSize: i18n.t('max_file_size'),
        },
    },
    FileDropZone: {
        dragDropUpload: i18n.t('drag_and_drop_to_upload'),
        or: i18n.t('or'),
        selectFile: i18n.t('select_file'),
    },
    Errors: {
        fileTypeError: i18n.t('file_type_error'),
        fileDimensionError: function (uploadImageMinWidth, uploadImageMinHeight) {
            return i18n.t('file_dimension_error', {
                uploadImageMinWidth: uploadImageMinWidth,
                uploadImageMinHeight: uploadImageMinHeight,
            });
        },
    },
};
export default Strings;
